import { ChangeDetectionStrategy, Component, Input } from '@angular/core';

@Component({
  selector: 'app-student-avatar-initials',
  templateUrl: './student-avatar-initials.component.html',
  styleUrls: ['./student-avatar-initials.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: []
})
export class StudentAvatarInitialsComponent {
  @Input() avatar: string;
  @Input() initials: string;
}
